module.exports = __webpack_public_path__ + "img/tc.803e18a2.svg";